import {useEffect, useRef, useState} from "react";
import styles from './index.module.less'
import UEditor from "../components/UE";
import {getFileUrlPrefix, getMeetReport, saveMeetReport} from "@/services/productContentConfig/customer.ts";
import {Button, Col, message, Row} from "antd";
import {useLocation, useNavigate} from "react-router-dom";

const meetReport = () => {
  const location = useLocation();
  const navigater = useNavigate();
  const {state} = location;
  const UE = useRef<any>();
  const changeContent = useRef<any>();
  const [data, setData] = useState<any>('');
  const [fileUrlPrefix, setFileUrlPrefix] = useState<string>('');
  const [ueContent, setUEContent] = useState(''); // 富文本内容
  const [isPullLoading, setIsPullLoading] = useState(false);

  useEffect(() => {
    fetchOptions();
  }, []);

  useEffect(() => {
    fileUrlPrefix && getInitData();
  }, [fileUrlPrefix])

  const getInitData = async () => {
    const {caseReport} = state;
    if (caseReport) {
      setData(caseReport);
      setUEContent(caseReport);
    } else {
      setTemp()
    }
  }

  const onPullBack = () => {
    setIsPullLoading(true)
    setTemp()
  }

  const setTemp = async () => {
    const {id, budgetInfo} = state;
    const caseList: any[] = await getMeetReport(id);
    const startStr: string = `<p>&nbsp;&nbsp;&nbsp;&nbsp;尊敬的客户您好，感谢您对生活家的信任，在今天的见面沟通中，我们确定了您对新家的需求，以下是我们今天沟通的见面报告，请查阅。</p><p></p>`
    const endStr: string = `<p></p><p>后续服务标准：</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;尊敬的客户您好，接下来的几天时间，设计师将为您完成设计深化，包含但不限于：量房服务、设计方案调整、预算调整、选材推荐、全案产品规划等。为了确保能够继续有效地沟通并解决您的问题，设计师会在接下来的几天内持续与您联系，以跟进这些行动步骤并解答任何进一步的问题并在深化过程中实时与您沟通，在此过程中，如果您有任何需要帮助或想要进一步讨论的事项，欢迎随时与我们的设计团队联系。生活家家居我们将竭诚为您提供优质服务，期待与您的再次见面。</p>`
    let str: string = '';
    const baseStr = (data: Record<string, any>): void => {
      data.forEach(item => {
        let needStr = '';
        let recommendStr = ''
        item.fieldList?.forEach((fieldItem, i: number) => {
          if (fieldItem.name)
            needStr += `<li>${fieldItem.name}：${fieldItem.fieldValDesc || '无'}</li>`
        })

        item.suggestVoList?.forEach((vo, i: number) => {
          recommendStr += `<div><img src=${fileUrlPrefix}${vo.spaceCase.caseImg} /></div>`
        })
        str += `
            <h4>${item.spaceName}</h4>
            <p>客户需求：</p>
            <ol>
              ${needStr}
            </ol>
            <p></p>
            <p>智能推荐：</p>
            <div> 
            ${recommendStr}
           </div>`
      })
    }
    baseStr(caseList);
    const amountStr: string = `
        <p></p>
        <p>合同金额：</p>
        <div id="budgetInfo" >${budgetInfo ? budgetInfo : '暂无'}</div>`;
    const result: string = startStr + str + amountStr + endStr;
    setData(result);
    setUEContent(result);
    setIsPullLoading(false)
  }

  const fetchOptions = async () => {
    const data:any = await getFileUrlPrefix();
    setFileUrlPrefix(data.prefix);
  }

  const onChangeEditor = (v) => {
    setUEContent(v)
  }

  const onSave = (sendCustomer: boolean) => {
    const budgetInfo = document.getElementById('budgetInfo')?.innerHTML
    saveMeetReport({data: {id: state.id, caseReport: ueContent, sendCustomer, budgetInfo}}).then(() => {
      message.success('操作成功');
      navigater(-1)
    })
  }

  return <Row justify={'center'} className={styles.AddContentCon}>
    <Col xxl={6} xl={9} className={styles.previewBox}>
      <div
          id="previewIframe"
          className={styles.previewIframe}
          dangerouslySetInnerHTML={{__html: ueContent}}
      ></div>
    </Col>
    <Col span={15}>
      <UEditor
          fileUrlPrefix={fileUrlPrefix} baseData={data} ref={UE}
          onChange={(v: string) => onChangeEditor(v)}
      />
    </Col>
    <div id={'editHtml'} style={{width: 0, height: 0, overflow: 'hidden'}}
         dangerouslySetInnerHTML={{__html: changeContent.current}}></div>
    <Col span={24} style={{display: 'flex', justifyContent: 'flex-end'}}>
      <Button type={'primary'} onClick={() => onPullBack()} style={{marginRight: 10}}
              loading={isPullLoading}>重新拉取</Button>
      <Button type={'primary'} onClick={() => onSave(false)}>保存</Button>
      <Button type={'primary'} style={{marginLeft: 10}} onClick={() => onSave(true)}>保存并推送客户</Button>
    </Col>
  </Row>
}

export default meetReport;